<template>
  <div :class="cardContainerClass" :style="loadCustomCardStyle">
    <HlsVideoPlayer
      :src="cameraData.streaming_url"
      :controls="false"
      @played="(e) => this.$emit('played', e)"
    />
    <div class="mt-2">
      <h4
        class="text-uppercase"
        :class="fullscreen ? 'text-h5' : 'text-h6'"
        :style="{ color: cardConfig.dscCorFonte }"
      >
        {{ cameraData.endereco }}
      </h4>
    </div>
  </div>
</template>

<script>
import HlsVideoPlayer from "@/components/HlsVideoPlayer.vue";
export default {
  components: { HlsVideoPlayer },
  props: {
    cameraData: { type: Object, required: true },
    cardConfig: { type: Object, default: null },
    fullscreen: { type: Boolean, default: false },
  },
  computed: {
    cardContainerClass() {
      const classes = ["card-container"];
      if (this.fullscreen) classes.push("card-container-fullscreen");
      // theme class when no custom card config
      if (!this.cardConfig) {
        const isDark = localStorage.getItem("@socialcam/is_dark_theme") === "true";
        classes.push(isDark ? "darkThemeStyle" : "lightThemeStyle");
      }
      return classes;
    },
    loadCustomCardStyle() {
      // Allow dynamic background (acts like border) and padding override via CSS var
      return this.cardConfig
        ? {
            background: this.cardConfig?.dscCorCard,
            "--card-padding": this.cardConfig?.padding ?? undefined,
          }
        : {};
    },
  },
};
</script>

<style lang="scss" scoped>
/* Base card tile — responsive */
.card-container {
  /* Fill parent grid column */
  width: 100%;

  /* Keep consistent visual shape for camera tiles */
  //   aspect-ratio: 16 / 9;

  /* Center the video player */
  display: grid;
  place-items: center;

  /* Background as border (responsive thickness) */
  padding: var(--card-padding, clamp(6px, 2vw, 12px));
  box-sizing: border-box;

  /* Allow background to be visible around contained media */
  overflow: hidden;

  /* The player handles its own sizing; :deep is a safe fallback */
  :deep(video) {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
  }
}

/* Fullscreen variant — fills viewport while keeping border space */
.card-container-fullscreen {
  width: 100%;
  height: 100vh;
  aspect-ratio: auto; /* ignore aspect ratio in fullscreen */
  display: grid;
  place-items: center;
  padding: var(--card-padding, clamp(12px, 2.5vw, 24px));
  box-sizing: border-box;
  border-radius: 0; /* typical fullscreen aesthetic */
}

/* Theme fallbacks when no cardConfig is provided */
.darkThemeStyle {
  background-color: #1f1f1f;
}
.lightThemeStyle {
  background-color: #f4f4f4;
}

/* Small-screen tweaks */
@media (max-width: 600px) {
  .card-container {
    padding: var(--card-padding, clamp(8px, 3vw, 14px));
  }
}
</style>
